(()=>{
const key='__afRccMediaV51';
if(window[key]){window[key](document);return;}
const seen=new WeakSet();
function init(scope){
const root=scope.matches?.('#af-landing')?scope:scope.querySelector('#af-landing');
if(!root||seen.has(root))return;seen.add(root);
const mainImage=root.querySelector('#gallery-main');
const galleryButtons=[...root.querySelectorAll('[data-gallery-src]')];galleryButtons.forEach((button,i)=>{button.setAttribute('aria-pressed',String(i===0));button.addEventListener('click',()=>{if(!mainImage)return;mainImage.src=button.dataset.gallerySrc;mainImage.alt=button.dataset.galleryAlt;galleryButtons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));const count=root.querySelector('[data-gallery-count]');if(count)count.textContent=(i+1)+' / '+galleryButtons.length;});});
const mini=root.querySelector('[data-mini-track]');
if(mini){
 const cards=[...mini.children],count=root.querySelector('[data-mini-count]');
 const go=direction=>{const width=mini.clientWidth;if(!width||!cards.length)return;const current=Math.round(mini.scrollLeft/width);mini.scrollTo({left:((current+direction+cards.length)%cards.length)*width,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
 root.querySelector('[data-mini-prev]')?.addEventListener('click',()=>go(-1));
 root.querySelector('[data-mini-next]')?.addEventListener('click',()=>go(1));
 mini.addEventListener('scroll',()=>{if(count&&mini.clientWidth)count.textContent=(Math.round(mini.scrollLeft/mini.clientWidth)+1)+' / '+cards.length;},{passive:true});
}
const reviews=root.querySelector('.photo-reviews');
if(reviews){
 const cards=[...reviews.children],count=root.querySelector('[data-final-count]');let index=0;
 const go=direction=>{if(!cards.length)return;index=(index+direction+cards.length)%cards.length;reviews.scrollBy({left:cards[index].getBoundingClientRect().left-reviews.getBoundingClientRect().left,behavior:'smooth'});if(count)count.textContent=(index+1)+' / '+cards.length;};
 root.querySelector('[data-final-prev]')?.addEventListener('click',()=>go(-1));
 root.querySelector('[data-final-next]')?.addEventListener('click',()=>go(1));
 reviews.addEventListener('scroll',()=>{if(!cards.length)return;const step=cards[0].getBoundingClientRect().width+16;index=Math.min(cards.length-1,Math.round(reviews.scrollLeft/step));if(count)count.textContent=(index+1)+' / '+cards.length;},{passive:true});
}
const media=root.hasAttribute('data-landing-media-gif') ? {
gif:root.dataset.landingMediaGif,videos:[root.dataset.landingVideo1,root.dataset.landingVideo2]
} : (window.landingMedia||{});
if(media.gif){const image=root.querySelector('[data-gif-slot] img');if(image)image.src=media.gif;}
root.querySelectorAll('[data-video-slot]').forEach((slot,i)=>{if(slot.querySelector('[data-native-video]'))return;const url=(media.videos||[])[i];if(!url)return;const video=document.createElement('video');video.src=url;video.controls=true;video.playsInline=true;video.preload='metadata';const poster=slot.querySelector('img');if(poster)video.poster=poster.src;video.style.cssText='width:100%;height:100%;object-fit:contain;background:#111';slot.replaceChildren(video);});

(()=>{const form=root.querySelector('#af-v1-product-form');const trigger=form?.querySelector('[data-dla-buy]');if(!form||!trigger||trigger.dataset.dlaBound==='true')return;trigger.dataset.dlaBound='true';trigger.addEventListener('click',()=>{const appButton=root.querySelector('#es-popup-button');if(appButton){appButton.click();return;}const native=form.querySelector('.dla-native-submit');if(native)native.click();});})();
}
window[key]=init;
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});}else{init(document);}
document.addEventListener('shopify:section:load',event=>init(event.target));
})();

// Rotating activity counter.
(()=>{
const key='__afDlaActivityRandomV1';
if(window[key]){window[key](document);return;}
const selector='[data-activity-random="true"]';
const active=new Map();
function stop(node){const state=active.get(node);if(state)clearTimeout(state.timer);active.delete(node);}
function schedule(node,state){
  clearTimeout(state.timer);
  if(document.hidden)return;
  state.timer=setTimeout(()=>{
    if(!node.isConnected){stop(node);return;}
    const step=(1+Math.floor(Math.random()*5))*(Math.random()<0.5?-1:1);
    let next=state.value+step;
    if(next<70||next>100)next=state.value-step;
    state.value=next;
    state.count.textContent=String(next);
    schedule(node,state);
  },6000);
}
function init(scope){
  for(const node of active.keys())if(!node.isConnected)stop(node);
  const nodes=scope.matches?.(selector)?[scope]:scope.querySelectorAll(selector);
  for(const node of nodes){
    if(active.has(node))continue;
    const count=node.querySelector('[data-activity-count]');if(!count)continue;
    const initial=Number(count.textContent);
    const state={count,value:Number.isInteger(initial)&&initial>=70&&initial<=100?initial:87,timer:null};
    count.textContent=String(state.value);active.set(node,state);schedule(node,state);
  }
}
window[key]=init;
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:section:unload',event=>{
  for(const node of active.keys())if(event.target===node||event.target.contains(node))stop(node);
});
document.addEventListener('visibilitychange',()=>{
  for(const [node,state] of active){if(!node.isConnected)stop(node);else schedule(node,state);}
});
})();
